import React, { RefObject } from 'react';
import FE from 'froala-editor';
import { AnchorRef } from '@/components/ui/Anchor';
import ReactDOM from 'react-dom';
import TextVariablePopover from './TextVariablePopover';
import { icon } from './icon';
import { handleTextVariableDeleteClick } from './TextVariableDeleteHandler';
import { SCORE_CONTAINER_CLASS_NAME } from './TextVariablePopover/TotalSlideShowScore/TotalSlideShowScore.utils';

type TextVariableProps = {
  locale?: 'en' | 'es';
  editorInstance: any;
  textVariableRef: RefObject<AnchorRef>;
};

export const TEXT_VARIABLE = {
  commandName: 'TextVariable' as const,
  events: {
    click({ textVariableRef, editorInstance, locale } : TextVariableProps) {
      let popoverRoot = document.querySelector('#insert-variable-root');
      if (popoverRoot) {
        ReactDOM.unmountComponentAtNode(popoverRoot);
        popoverRoot.parentNode?.removeChild(popoverRoot);
      }
      popoverRoot = document.createElement('div');
      popoverRoot.id = 'insert-variable-root';
      document.body.appendChild(popoverRoot);

      ReactDOM.render(
        <TextVariablePopover
          editorInstance={editorInstance}
          locale={locale}
          popoverRef={textVariableRef}
        />,
        popoverRoot,
      );
    },
    textVariableClick(e: MouseEvent, selector: string, editorInstance: any) {
      editorInstance.toolbar.enable();

      // Any other TextVariable types that need just a delete popup on click can be added here
      handleTextVariableDeleteClick(e, selector, editorInstance, {
        className: SCORE_CONTAINER_CLASS_NAME,
        popoverRootId: `${SCORE_CONTAINER_CLASS_NAME}-root`,
      });
    },
  },
  icon,
  locale: 'en' as Locale,
  name: 'Text Variable' as const,
};

export const textVariablePluginCommand = () => {
  FE.DefineIcon(
    TEXT_VARIABLE.commandName,
    { ICON: TEXT_VARIABLE.icon },
  );

  FE.RegisterCommand(TEXT_VARIABLE.commandName, {
    focus: false,
    icon: TEXT_VARIABLE.icon,
    refreshAfterCallback: true,
    title: 'Insert Text Variable',
    undo: true,
  });
};
